var render = function render(){
  var _vm$images;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('draggable', {
    staticClass: "row row--small",
    attrs: {
      "draggable": ".image-item"
    },
    on: {
      "change": _vm.emit
    },
    scopedSlots: _vm._u([_vm.mode != 'view' ? {
      key: "footer",
      fn: function () {
        return [_c('v-col', _vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showsAddButton,
            expression: "showsAddButton"
          }],
          staticClass: "d-flex align-center justify-center pl-lg-10"
        }, 'v-col', Object.assign({}, _vm.$attrs, {
          cols: _vm.cols
        }), false), [_c('v-btn', {
          attrs: {
            "icon": "",
            "text": "",
            "color": "transparent"
          },
          on: {
            "click": _vm.onClick
          }
        }, [_c('i', {
          staticClass: "icon icon-plus-sm"
        })]), _c('v-file-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false"
          }],
          ref: "file-input",
          attrs: {
            "accept": "image/*"
          },
          on: {
            "change": _vm.onChange
          }
        })], 1)];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.files,
      callback: function ($$v) {
        _vm.files = $$v;
      },
      expression: "files"
    }
  }, [_vm._l(_vm.images, function (_ref) {
    var file = _ref.file,
      src = _ref.src;
    return [_c('v-col', _vm._b({
      key: file.name,
      staticClass: "image-item",
      staticStyle: {
        "cursor": "pointer"
      }
    }, 'v-col', Object.assign({}, _vm.$attrs, {
      cols: _vm.cols
    }), false), [_vm.mode == 'view' ? _c('v-responsive', {
      attrs: {
        "aspect-ratio": 1 / 1
      }
    }, [_c('v-image-popup', _vm._b({
      attrs: {
        "hideActivator": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref2) {
          var attrs = _ref2.attrs,
            on = _ref2.on;
          return _c('v-img', _vm._g(_vm._b({
            staticClass: "min-w-lg-100px",
            attrs: {
              "aspect-ratio": 1 / 1,
              "src": src
            }
          }, 'v-img', attrs, false), on));
        }
      }], null, true)
    }, 'v-image-popup', {
      src
    }, false))], 1) : _vm._e(), _vm.mode == 'menu' ? _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref3) {
          var attrs = _ref3.attrs,
            on = _ref3.on;
          return _c('v-img', _vm._g(_vm._b({
            staticClass: "min-w-lg-100px",
            attrs: {
              "aspect-ratio": 1 / 1,
              "src": src
            },
            on: {
              "mouseover": function ($event) {
                return _vm.$emit('mouseover', file);
              }
            }
          }, 'v-img', attrs, false), on));
        }
      }], null, true)
    }, [_c('v-list', [_c('v-list-item', {
      staticClass: "font-size-14",
      on: {
        "click": function ($event) {
          return _vm.remove(file);
        }
      }
    }, [_vm._v("삭제하기")])], 1)], 1) : _vm._e(), _vm.mode == 'hover' ? _c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (_ref4) {
          var hover = _ref4.hover;
          return [_c('v-img', {
            attrs: {
              "aspect-ratio": 1 / 1,
              "src": src,
              "content-class": "d-flex align-center justify-center"
            },
            on: {
              "mouseover": function ($event) {
                return _vm.$emit('mouseover', file);
              }
            }
          }, [_c('v-fade-transition', [_c('v-btn', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: hover,
              expression: "hover"
            }],
            attrs: {
              "icon": "",
              "color": "black"
            },
            on: {
              "click": function ($event) {
                return _vm.remove(file);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)], 1)], 1)];
        }
      }], null, true)
    }) : _vm._e()], 1)];
  }), _vm.mode == 'view' && !((_vm$images = _vm.images) !== null && _vm$images !== void 0 && _vm$images.length) ? [_vm._v(" " + _vm._s(_vm.noImageMessage) + " ")] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }